import { render, staticRenderFns } from "./XBtn.vue?vue&type=template&id=e137e0bc&scoped=true"
import script from "./XBtn.vue?vue&type=script&lang=js"
export * from "./XBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e137e0bc",
  null
  
)

export default component.exports